import React from 'react';
import { useLanguage } from '../LanguageContext';
export const Footer = () => {
  const {
    t
  } = useLanguage();
  return <footer className="bg-slate-950 py-12 border-t border-slate-800" data-id="element-43">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-44">
        <div className="flex items-center gap-2" data-id="element-45">
          <div className="w-8 h-8 rounded-full bg-indigo-600 flex items-center justify-center text-white font-bold text-sm" data-id="element-46">
            MR
          </div>
          <span className="font-bold text-lg text-white tracking-tight" data-id="element-47">
            Mora Rebori
          </span>
        </div>

        <div className="text-slate-500 text-sm" data-id="element-48">
          © {new Date().getFullYear()} {t.footer.rights}
        </div>
      </div>
    </footer>;
};